import React from "react";

import { Button, Icon } from "aible";

import AibleStep from "containers/CreateWizard/AibleStep";

import DatasetTile from "components/Tiles/DatasetTile";
import BlueprintTile from "components/Tiles/BlueprintTile";

import styles from "./style.module.css";

export default class BusinessChooseDataset extends React.PureComponent {
  render() {
    const {
      blueprintId,
      id,
      isShow,

      step,
      index,

      datasetView,
      blueprintView,
      selectedDataset,
      selectedBlueprint,
      selectedBlueprintId,
      updateDataset,
      updateBlueprint
    } = this.props;

    let stepMessage = "Dataset and Blueprint selected";
    if (!selectedDataset || !selectedBlueprint) {
      stepMessage =
        "Select" +
        (!selectedDataset ? " a Dataset" : "") +
        (!selectedDataset && !selectedBlueprint ? " and" : "") +
        (!selectedBlueprint ? " a Blueprint" : "");
    }

    return (
      <div className={styles.businessChooseDataset} style={{ width: "100%", opacity: isShow === true ? 1 : 0 }}>
        <div id="businessChooseDataset" style={{ width: "100%" }}>
          <AibleStep id={id} bId="businessChooseDataset" message={stepMessage} isBreak>
            <div className={styles.businessChooseWrapper}>
              <div className={styles.businessChooseCol + " " + (selectedBlueprint ? "" : styles.grow)}>
                <div className={styles.businessChooseItem}>
                  {selectedBlueprint ? (
                    <div className={styles.businessSelectedItem}>
                      <div className={styles.selectHeader} style={{ marginLeft: "10px" }}>
                        <Icon type={"blueprint"} />
                        <div className={styles.selectHeaderText}>{"Selected Blueprint"}</div>
                      </div>
                      <BlueprintTile isQuickStart={selectedBlueprintId === "academic"} blueprint={selectedBlueprint} />
                      <Button onClick={() => updateBlueprint(undefined)}>{"Change"}</Button>
                    </div>
                  ) : (
                    <div className={styles.businessSelectItem}>{blueprintView}</div>
                  )}
                </div>
              </div>
              <div className={styles.businessChooseCol + " " + (selectedDataset ? "" : styles.grow)}>
                <div className={styles.businessChooseItem}>
                  {selectedDataset ? (
                    <div className={styles.businessSelectedItem}>
                      <div className={styles.selectHeader} style={{ marginLeft: "10px" }}>
                        <Icon type={"dataset"} />
                        <div className={styles.selectHeaderText}>{"Selected Dataset"}</div>
                      </div>
                      <DatasetTile dataset={selectedDataset} />
                      <Button onClick={() => updateDataset(undefined)}>{"Change"}</Button>
                    </div>
                  ) : (
                    <div className={styles.businessSelectItem}>{datasetView}</div>
                  )}
                </div>
              </div>
            </div>
          </AibleStep>
        </div>
      </div>
    );
  }
}
